import axios from 'axios';
import { getConfig } from '../../../../src/Config';

const portalPublicEndpoint = getConfig().portalPublicUrl;

export const sendFeedbackForm = (feedbackData) => {
  return axios.post(`${portalPublicEndpoint}/feedback`, feedbackData);
};
